import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import {
  CreateUpdateArticleDto,
  CreateUpdateArticleDtoFromJSON,
  CreateUpdateArticleHarmfulFactorSuppExamDictDto,
  GetArticleDto,
  GetArticleHarmfulFactorSuppExamDictDto,
  GetLastEditorDto,
} from '../autogenerated/spdApiClient';
import { validateAgainst } from '../validation/validateAgainst';
import { ArticleMode, ArticleSchema } from '../validation/schemas';

export type ArticleEntity = GetArticleDto;

export interface ArticleContextInterface {
  get: (id: string) => Promise<ArticleEntity>;
  getAll: (mode?: ArticleMode) => Promise<GetArticleDto[]>;
  update: (id: string, dto: CreateUpdateArticleDto) => Promise<void>;
  create: (dto: CreateUpdateArticleDto) => Promise<GetArticleDto>;
  changeToInactive: (id: string) => Promise<void>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
}

export const ArticleContext = (api: DefaultApi) => {
  return {
    get: async (id: string) => {
      return await api.articleControllerGet(id);
    },

    getAll: (mode?: ArticleMode) =>
      api.articleControllerGetAll(mode?.toString()),

    update: (id: string, dto: CreateUpdateArticleDto) =>
      api.articleControllerUpdate(id, dto),

    create: (dto: CreateUpdateArticleDto) => api.articleControllerCreate(dto),

    changeToInactive: (id: string) => api.articleControllerChangeToInactive(id),

    getLastEditor: (id: string) => api.articleControllerGetLastEditor(id),
  };
};

export const articleHarmfulFactorSuppExamDictData = (
  e: GetArticleHarmfulFactorSuppExamDictDto,
): CreateUpdateArticleHarmfulFactorSuppExamDictDto => ({
  harmfulFactorId: e.harmfulFactorId ?? undefined,
  supportingExaminationDictId: e.supportingExaminationDictId ?? undefined,
});

export const validate = (test: CreateUpdateArticleDto) =>
  validateAgainst(ArticleSchema, test);

export const articleData = (
  article?: GetArticleDto,
): CreateUpdateArticleDto => {
  if (!article) {
    return CreateUpdateArticleDtoFromJSON({ mode: ArticleMode.Doctor });
  }

  return CreateUpdateArticleDtoFromJSON({
    ...article,
    ...{
      registerId: article?.register?.id,
      pricingGroupId: article?.pricingGroup?.id,
    },
  });
};
